import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Modal, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Card } from "components/Card/Card.jsx";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import Select from 'react-select';
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import { listActions } from '../../../redux/actions/list-actions';
import { brandActions } from '../../../redux/actions/brand-actions';
import { helperFunctions as HF } from "helper/helperFunctions";
import { hasPermission } from 'helper/hasPermission';
import { shippingOptionsActions } from "../../../redux/actions/shipping-options-actions";
import { orderService } from "../../../services/order";
import OrderBulkEditForm from './Forms/OrderBulkEditForm';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { IoMdAdd, IoMdRemove } from 'react-icons/io'
import { CSVDownloader } from 'react-papaparse'
import DatePicker from 'react-date-picker';
import { alertActions } from "../../../redux/actions/alert-actions";

var cloneDeep = require('lodash.clonedeep');
var moment = require("moment");

const dropdownFields = [
    {
        title: 'Company',
        name: 'customer_title',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Bill-To Party',
        name: 'billing_title',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Bill-To Party Contact',
        name: 'billing_contact_name',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Bill-To Party Email',
        name: 'billing_email',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Ship Date',
        name: 'ship_date',
        type: 'date',
        deletable: true,
    },
    {
        title: 'Ship-To Party',
        name: 'shipping_title',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Ship-To Party Contact',
        name: 'shipping_contact_name',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Ship-To Party Email',
        name: 'shipping_email',
        type: 'text',
        deletable: true,
    },
    {
        title: 'Tracking No.',
        name: 'tracking_number',
        type: 'text',
        deletable: true,
    },
    {
        title: 'User Id',
        name: 'user_name',
        type: 'text',
        deletable: true,
    },
]

const baseFilters = [
    {
        title: 'Brand',
        name: 'brand',
        type: 'dropdown'
    },
    {
        title: 'Print Location',
        name: 'print_location',
        type: 'dropdown'
    },
    {
        title: 'Status',
        name: 'status',
        type: 'dropdown'
    },
    {
        title: 'Order Date',
        name: 'order_date',
        type: 'order_date'
    },
]

// const gridInputFields = { ship_account: {}, shipped_by_contact_name: {}, tracking_number: {}, ship_date: {} };
class OrderList extends Component {
    constructor(props) {
        super(props);
        const sessStateExists = JSON.parse(sessionStorage.getItem('orderGridState'));
        let sessState = {};
        if (sessStateExists) {
            sessState = sessStateExists;
        }
        this.state = {
            addModal: false,
            editModalState: false,
            sorted: "",
            filtered: "",
            brandId: "",
            pageSize: 10,
            orders: [],
            brands: [],
            brandsData: [],
            orders_to_download: [],
            checked: "",
            selectedField: "",
            page: 1,
            selected_orders_ids: [],
            additional_filters: [...baseFilters],
            filter_values: {},
            included_filters: {},
            // adding additional orderstracingnumber for faster rendering
            gridInputFields: {},
            checkedOrders: [],
            checkedOrdersIds: [],
            all_checked: false,
            add_filters: false,
            table_columns: [],
            showDropdown: this.props.match.params.id !== "all" ? true : true,
            fromDashboard: this.props.dashboard !== undefined ? true : false,
            userInfo: JSON.parse(localStorage.getItem("user")).result.user,
            ...sessState,
        };
        this.check_all_ref = React.createRef();
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
    }

    filterSearchHandle(e) {
        this.setState(
            {
                filtered: e.target.value
            },
            () => {
                this.refreshOrdersList();
            }
        );
    }

    ordersPaginationData = (page, filtered, sort, pageSize,) => {
        try {
            const { add_filters, included_filters } = this.state;
            this.setState({ pageSize: pageSize }, async function () {
                const res = await this.props.getOrdersListCall('', page, pageSize, sort, true,
                    { filter: add_filters ? included_filters : null }
                );
                this.setState({
                    orders: this.markAlreadySelectedOrders(res.data),
                    gridInputFields: this.maintainOrderTrackingNumbers(res.data)
                })
            });
        } catch (e) {
            console.log('Err', e);
        }
    };

    maintainOrderTrackingNumbers = (orders = []) => {
        let temp = {};
        orders.forEach(item => {
            let ship_date = null;
            if (item.ship_date) {
                ship_date = new Date(item.ship_date)
            }
            temp[item.id] = {
                ship_account: {
                    value: item.ship_account || '',
                    orgValue: item.ship_account || '',
                },
                tracking_number: {
                    value: item.tracking_number || '',
                    orgValue: item.tracking_number || '',
                },
                shipped_by_contact: {
                    value: item.shipped_by_contact || '',
                    orgValue: item.shipped_by_contact || '',
                },
                ship_date: {
                    value: ship_date,
                    orgValue: ship_date
                },
                ship_via: {
                    value: item.ship_via || '',
                    orgValue: item.ship_via || ''
                },
            }
        })
        return temp;
    }

    markAlreadySelectedOrders = (orders = []) => {
        let all_selected_ids = [...this.state.selected_orders_ids];
        let ids = [];
        orders.forEach(ord => {
            if (all_selected_ids.includes(ord.id)) {
                ids.push(ord.id)
            }
        })
        let temp_orders = cloneDeep(orders).map(item => {
            if (ids.includes(item.id)) {
                item.selected = true;
            } else {
                item.selected = false
            }
            return item;
        });
        if (this.check_all_ref && this.check_all_ref.current)
            this.check_all_ref.current.checked = false;
        this.setState({
            selected_orders_ids: ids
        })
        return temp_orders;
    }

    refreshOrdersList = (pageSize = 10) => {
        const { included_filters, add_filters } = this.state;
        this.props
            .getOrdersListCall(
                this.state.brandId || '',
                this.state.page,
                this.state.pageSize,
                '',
                true,
                { filter: add_filters ? included_filters : null }
            )
            .then(response => {
                this.setState({
                    orders: this.markAlreadySelectedOrders(this.props.ordersData),
                    gridInputFields: this.maintainOrderTrackingNumbers(this.props.ordersData)
                });
            });
    };

    getFullState = state => {
        this.setState(
            prevState => ({
                brandId: state.model_id
            }),
            () => {
                this.refreshOrdersList();
            }
        );
    };

    getOrderStatusOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title }) => ({
            value: title,
            // label: HF.Capitalize(title)
            label: title
        }));
    }

    handleGridInputBlur = async (e, original, fieldType = null) => {
        const { gridInputFields } = this.state;
        let value = e.target.value;
        let field_name = e.target.name;
        if (!value) value = ''
        if (value === gridInputFields[original.id][field_name]['orgValue']) return;
        try {
            const res = await orderService.updateOrderGrid({
                order_id: original.id,
                field: {
                    field_name,
                    value: gridInputFields[original.id][field_name] ? gridInputFields[original.id][field_name].value : ''
                }
            });
            this.props.successAlert(res.message)
        } catch (e) {
            this.props.errorAlert(e)
        }
        this.refreshOrdersList();
        this.downloadData();
    }

    handleGridInput = (e, original, fieldType = null) => {
        const tempFields = { ...this.state.gridInputFields };
        let tempObj = { ...tempFields[original.id] };
        tempObj[e.target.name].value = e.target.value;
        tempFields[original.id]
        this.setState({
            gridInputFields: tempFields
        })
    }


    handleGridDatePicker = async (value, original, field_name = "") => {
        const { gridInputFields } = this.state;
        const tempFields = { ...this.state.gridInputFields };
        let tempObj = { ...tempFields[original.id] };
        if (!value) value = null
        tempObj[field_name].value = value;
        this.setState({
            gridInputFields: tempFields
        })
        if (value === gridInputFields[original.id][field_name]['orgValue']) return;
        try {
            const res = await orderService.updateOrderGrid({
                order_id: original.id,
                field: {
                    field_name,
                    value,
                }
            });
            this.props.successAlert(res.message);
            this.downloadData();
            this.refreshOrdersList();
        } catch (e) {
            this.props.errorAlert(e);
            console.log("🚀 ~ file: OrderList.jsx ~ line 320 ~ OrderList ~ handleGridDatePicker= ~ e", e)
        }
    }

    handleChangeDropdown = async (selectedOption, info, original, index) => {
        try {
            // if (info.name === 'ship_via') {
            //     await orderService.updateOrderShippingVia({
            //         order_id: original.id,
            //         ship_via_id: selectedOption.value,
            //         ship_via: selectedOption.label,
            //     })
            //     this.refreshOrdersList();
            //     return;
            // }
            // await this.props.saveOrderStatusCall(
            //     {
            //         status: selectedOption.value,
            //         id: original.id
            //     }
            // )
            const res = await orderService.updateOrderGrid({
                order_id: original.id,
                field: {
                    field_name: info.name,
                    value: selectedOption.value,
                    label: selectedOption.label
                }
            });
            this.props.successAlert(res.message);
            this.refreshOrdersList();
            this.downloadData();
        } catch (e) {
            this.props.errorAlert(e);
            console.log("🚀 ~ file: OrderList.jsx ~ line 153 ~ OrderList ~ handleChangeDropdown= ~ e", e)
        }
    }

    componentDidMount = () => {
        if (this.props.brandDashboard) {
            this.setState({
                brandId: this.props.brandId
            }, () => {
                this.refreshOrdersList();
            })
        } else {
            this.props.getListCall('order_status', "", "", "", "", "order_status", false);
            this.props.getListCall('print_location', "", "", "", "", "print_location", false);
            this.props.getShippingOptions('all');
        }
        this.downloadData();
        let brands = [];
        if(hasPermission('customer-dashboard')) {

            let user = JSON.parse(localStorage.getItem('user'));
            if(user.result.user.role_id==8){
                this.props.getAllBrands().then(res => this.setState({brands: res.result.brands}));
            }
            else {
                this.props.getCustomerBrands().then(res => this.setState({brands: res.result.brands}));
            }
        } else {
            this.props.getAllBrands().then(res => this.setState({brands: res.result.brands}));
        }
        const cols = this.getColumns();
        this.setState({
            table_columns: cols
        })
    }

    processShippingOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title, account }) => ({
            value: id,
            label: HF.Capitalize(title),
            account_value: account
        }));
    }

    selectItem = (value, original, index, e) => {
        const checked = e.target.checked;
        let temp_orders = cloneDeep(this.state.orders);
        let ids = [];

        //* if value is null that means select all was clicked
        if (!value) {
            if (checked) {
                ids = temp_orders.map(ord => ord.id);
            }
            temp_orders.forEach(item => item.selected = checked)
        } else {
            ids = [...new Set([...this.state.selected_orders_ids, value])];
            if (!checked) {
                ids = ids.filter(id => {
                    return id !== value
                })
            }
            temp_orders[index].selected = checked;
        }
        this.setState({
            selected_orders_ids: [...ids],
            orders: temp_orders
        })
    }

    getColumns = () => {
        const columns = [
            {
                Header: "States Listing",
                headerClassName: "headerPagination",
                columns: [
                    {
                        Header: <React.Fragment>
                            <div>
                                <label>
                                    <input
                                        type="checkbox"
                                        style={{
                                            float: "left",
                                            margin: "4px 6px",
                                            width: '30px',
                                            height: '30px',
                                        }}
                                        key={'check-all-box'}
                                        id="check-all"
                                        ref={this.check_all_ref}
                                        // checked={this.state.all_checked}
                                        onChange={e => this.selectItem(null, null, null, e)}
                                    />
                                </label>
                            </div>
                        </React.Fragment>
                        ,
                        accessor: "id",
                        excExp: false,
                        className: "action-center",
                        show: hasPermission('change-order-status') ? true : false,
                        minWidth: 50,
                        sortable: false,
                        Cell: ({ value, original, index }) => (
                            <React.Fragment>
                                <div>
                                    <label>
                                        <input
                                            type="checkbox"
                                            style={{
                                                float: "left",
                                                margin: "4px 6px",
                                                width: '30px',
                                                height: '30px',
                                            }}
                                            key={value}
                                            id="check-single"
                                            checked={original.selected}
                                            onChange={e => this.selectItem(value, original, index, e)}
                                        />
                                    </label>
                                </div>
                            </React.Fragment>
                        )
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        excExp: false,
                        minWidth: 100,
                        Cell: ({ value }) => (
                            hasPermission('view-order-details') &&
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{`Edit Details`}</Popover>}>
                                    <span>
                                        {
                                            <Link to={`/Admin/order-detail/${value}`}><button type='button' style={{ fontSize: '10px' }} className="customBtn btnBlue">
                                                {hasPermission('change-order-status') ? 'Edit ' : 'View '}Order</button></Link>
                                        }
                                    </span>
                                </OverlayTrigger>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Order ID",
                        accessor: "id",
                        excExp: true,
                        minWidth: 60,
                        className: "action-center",
                        sortable: true
                    },
                    {
                        Header: "Order Date",
                        accessor: "date_ordered",
                        excExp: true,
                        minWidth: 100,
                        className: "action-center",
                        sortable: true,
                        Cell: ({ value }) => (
                            <div>
                                {moment(new Date(value)).format('YYYY-MM-DD')}
                                {/* {new Date(value).toLocaleDateString("en", dateFormatOptions )} */}
                            </div>
                        )
                    },
                    {
                        Header: "Print Location",
                        accessor: "print_location",
                        excExp: true,
                        minWidth: 100,
                        className: "action-center text-capitalize",
                        sortable: true,
                        getProps: () => {
                            return {
                                style: {
                                    overflow: 'visible'
                                },
                            };
                        },
                        Cell: ({ original, value, index }) => (
                            hasPermission('change-order-status') ?
                                <div style={{ width: "350px" }}>
                                    <Select
                                        value={HF.returnLabelWithValue(original.print_location_id, this.processShippingOptions(this.props.print_location))}
                                        onChange={(event, info) => this.handleChangeDropdown(event, info, original, index)}
                                        options={this.processShippingOptions(this.props.print_location)}
                                        isSearchable={false}
                                        isMulti={false}
                                        name='print_location'
                                        placeholder={'Select Loc'}
                                    />
                                </div>
                                : <div>{value}</div>
                        )
                    },
                    {
                        Header: "Brand",
                        accessor: "brand",
                        excExp: true,
                        minWidth: 120,
                        className: "action-center",
                        sortable: true
                    },
                    {
                        Header: "Company",
                        accessor: "customer_title",
                        minWidth: 300,
                        excExp: true,
                        className: "action-center",
                        sortable: true
                    },
                    {
                        Header: "User ID",
                        accessor: "user_name",
                        excExp: true,
                        minWidth: 250,
                        className: "action-center",
                        sortable: true
                    },
                    {
                        Header: "Status",
                        accessor: "status",
                        excExp: true,
                        className: "action-center text-capitalize",
                        minWidth: 150,
                        sortable: true,
                        getProps: () => {
                            return {
                                style: {
                                    overflow: 'visible'
                                },
                            };
                        },
                        Cell: ({ original, value }) => (
                            <React.Fragment>
                                {(hasPermission('change-order-status')) ?
                                    <div style={{ width: "350px" }}>
                                        <Select
                                            value={HF.returnLabelWithValue(value, this.getOrderStatusOptions(this.props.orderStatuses))}
                                            onChange={(event, info) => this.handleChangeDropdown(event, info, original)}
                                            options={this.getOrderStatusOptions(this.props.orderStatuses)}
                                            isSearchable={false}
                                            isMulti={false}
                                            name='status'
                                            placeholder={'Status'}
                                        />
                                    </div>
                                    :
                                    <div>{value}</div>
                                }
                            </React.Fragment>
                        )
                    },
                    {
                        Header: "Ship Via",
                        accessor: "ship_via",
                        excExp: true,
                        className: "action-center text-capitalize",
                        sortable: true,
                        minWidth: 140,
                        getProps: () => {
                            return {
                                style: {
                                    overflow: 'visible'
                                },
                            };
                        },
                        Cell: ({ original, value, index }) => (
                            hasPermission('change-order-status') ?
                                <div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="ship_via"
                                        value={this.state.gridInputFields[original.id] ? this.state.gridInputFields[original.id]['ship_via'].value : ''}
                                        onBlur={(e) => { this.handleGridInputBlur(e, original) }}
                                        onChange={(e) => { this.handleGridInput(e, original) }}
                                        style={{ fontSize: '10px' }}
                                    />
                                </div>
                                : <div>{value}</div>
                        )
                    },
                    {
                        Header: "Ship Account",
                        accessor: "ship_account",
                        excExp: true,
                        minWidth: 140,
                        className: "action-center",
                        sortable: true,
                        Cell: ({ original, value }) => (
                            hasPermission('change-order-status') ?
                                <div>
                                    <input className="form-control" style={{ fontSize: '10px' }}
                                        name="ship_account"
                                        value={this.state.gridInputFields[original.id] ? this.state.gridInputFields[original.id]['ship_account'].value : ''}
                                        onBlur={(e) => { this.handleGridInputBlur(e, original) }}
                                        onChange={(e) => { this.handleGridInput(e, original) }}
                                    />
                                </div>
                                : <div>{value}</div>
                        )
                    },
                    {
                        Header: "Shipped By Contact",
                        minWidth: 200,
                        accessor: "shipped_by_contact",
                        excExp: true,
                        className: "action-center",
                        sortable: true,
                        Cell: ({ original, value }) => (
                            hasPermission('change-order-status') ?
                                <div>
                                    <input className="form-control" style={{ fontSize: '10px' }}
                                        value={this.state.gridInputFields[original.id] ? this.state.gridInputFields[original.id]['shipped_by_contact'].value : ''}
                                        name="shipped_by_contact"
                                        onBlur={(e) => { this.handleGridInputBlur(e, original) }}
                                        onChange={(e) => { this.handleGridInput(e, original) }}
                                    />
                                </div>
                                : <div>{value}</div>
                        )
                    },
                    {
                        Header: "Tracking No.",
                        accessor: "tracking_number",
                        excExp: true,
                        className: "action-center",
                        sortable: true,
                        minWidth: 200,
                        Cell: ({ original, value, index }) => (
                            hasPermission('change-order-status') ?
                                <div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="tracking_number"
                                        value={this.state.gridInputFields[original.id] ? this.state.gridInputFields[original.id]['tracking_number'].value : ''}
                                        onBlur={(e) => { this.handleGridInputBlur(e, original) }}
                                        onChange={(e) => { this.handleGridInput(e, original) }}
                                        style={{ fontSize: '10px' }}
                                    />
                                </div>
                                : <div>{value}</div>
                        )
                    },
                    {
                        Header: "Ship Date",
                        accessor: "ship_date",
                        excExp: true,
                        className: "action-center",
                        sortable: true,
                        minWidth: 200,
                        resizable: false,
                        style: { overflow: 'visible' },
                        Cell: ({ original, value }) => (
                            hasPermission('change-order-status') ?
                                <div>
                                    <DatePicker
                                        className="form-control"
                                        value={this.state.gridInputFields[original.id] ? this.state.gridInputFields[original.id]['ship_date'].value : null}
                                        onChange={(e) => this.handleGridDatePicker(e, original, "ship_date")}
                                        // onBlur={(e) => { this.handleGridInputBlur(e, original, "date") }}
                                        placeholderText={`11/06/2022`}
                                    />
                                </div>
                                : <div>{value}</div>
                        )
                    },
                    {
                        Header: "Bill-To Party",
                        accessor: "billing_title",
                        excExp: true,
                        className: "action-center",
                        minWidth: 300,
                        sortable: true
                    },
                    {
                        Header: "Bill-To Party Contact",
                        accessor: "billing_contact_name",
                        excExp: true,
                        minWidth: 200,
                        className: "action-center",
                        sortable: true
                    },
                    {
                        Header: "Bill-To Party Email",
                        accessor: "billing_email",
                        excExp: true,
                        className: "action-center",
                        minWidth: 250,
                        sortable: true
                    },
                    {
                        Header: "Bill-To Party Phone",
                        accessor: "billing_phone",
                        excExp: true,
                        className: "action-center",
                        minWidth: 150,
                        sortable: true
                    },
                    {
                        Header: "Bill-To Party PO NO.",
                        accessor: "po_number",
                        excExp: true,
                        className: "action-center",
                        minWidth: 150,
                        sortable: true
                    },
                    {
                        Header: "Ship-To Party",
                        accessor: "shipping_title",
                        excExp: true,
                        className: "action-center",
                        minWidth: 300,
                        sortable: true
                    },
                    {
                        Header: "Ship-To Party Contact",
                        accessor: "shipping_contact_name",
                        excExp: true,
                        className: "action-center",
                        minWidth: 200,
                        sortable: true
                    },
                    {
                        Header: "Ship-To Party Email",
                        accessor: "shipping_email",
                        excExp: true,
                        className: "action-center",
                        minWidth: 250,
                        sortable: true
                    },
                    {
                        Header: "Ship-To Party Phone",
                        accessor: "shipping_phone",
                        excExp: true,
                        className: "action-center",
                        minWidth: 150,
                        sortable: true
                    },
                ]
            }
        ];
        return columns;
    }

    addNewField = () => {
        const { selectedField, additional_filters } = this.state;
        if (selectedField && !additional_filters.map(item => item.name).includes(selectedField.name)) {
            this.setState({
                additional_filters: [...additional_filters, selectedField]
            });
        }
    }

    removeField = (index, field) => {
        const { filter_values, additional_filters } = this.state;
        let tempArr = [...additional_filters];
        let tempValues = { ...filter_values };
        tempArr.splice(index, 1);
        if (filter_values[field.name]) {
            delete tempValues[field.name]
        }
        this.setState({
            ...this.state,
            additional_filters: tempArr,
            filter_values: tempValues
        })
    }

    handleFieldDropdown = (selectedOption) => {
        this.setState({
            selectedField: selectedOption
        })
    }

    getDropdownOptions = (name) => {
        switch (name) {
            case 'brand':
                return this.state.brands.sort((a, b) => a.title.localeCompare(b.title))
            case 'print_location':
                return this.props.print_location.sort((a, b) => a.title.localeCompare(b.title))
            case 'status':
                return this.props.orderStatuses.sort((a, b) => a.title.localeCompare(b.title))
            case 'order_date':
                return [{ title: 'All', id: 'all' }, { title: 'Last 7 days', id: 'last7' }, { title: 'Last 14 Days', id: 'last14' }, { title: 'Last 30 Days', id: 'last30' }, { title: 'Last 90 Days', id: 'last90' }, { title: 'Last 180 Days', id: 'last180' }, { title: 'Last 1 Year', id: 'lastYear' }]
            case 'ship_via':
                return this.props.shippingOptions.sort((a, b) => a.title.localeCompare(b.title))
            default:
                return []
        }
    }

    handleSearchDropdowns = (e, info, field) => {
        let { filter_values } = this.state;
        let temp_filters = { ...filter_values };
        let field_name = field.name;
        if (field.name === 'order_date') {
            field_name = `${field.name}_by_days`
            if (filter_values[field.name]) {
                delete temp_filters[field.name]
            }
        }
        if (e) {
            temp_filters[field_name] = {
                id: e.id,
                title: e.title,
                field_name,
                field_type: field.type
            }
        } else {
            delete temp_filters[field_name]
        }
        this.setState({
            filter_values: temp_filters
        })
    }

    handleSearchInputs = (e) => {
        const { value, name } = e.target;
        this.setState({
            filter_values: {
                ...this.state.filter_values,
                [name]: {
                    id: name,
                    title: value,
                    value: value,
                    field_name: name,
                    field_type: 'input'
                }
            }
        })
    }

    handleSearchDatePicker = (field, date) => {
        let { filter_values } = this.state;
        let temp_filters = { ...filter_values };
        if (field.type === 'order_date') {
            if (temp_filters[`${field.name}_by_days`]) {
                delete temp_filters[`${field.name}_by_days`]
            }
        }
        temp_filters[field.name] = {
            value: date,
            field_name: field.name,
            field_type: 'date'
        }
        if (!date) delete temp_filters[field.name];
        this.setState({
            filter_values: temp_filters
        })
    }

    renderAdditionalFilters = () => {
        return this.state.additional_filters.map((field, index) => {
            if (field.type === 'dropdown') {
                return <Col md={6} style={{ marginTop: '10px', display: 'flex', alignItems: 'end' }} key={field.name}>
                    <div style={{ width: '90%' }}>
                        <span>
                            <label>{field.title}</label>
                            <Select
                                value={this.state.filter_values[field.name] || ''}
                                onChange={(event, info) => this.handleSearchDropdowns(event, info, field)}
                                options={this.getDropdownOptions(field.name)}
                                getOptionLabel={(option) => option.title}
                                getOptionValue={(option) => option.id}
                                isSearchable={true}
                                isClearable={true}
                                name={field.value}
                                placeholder={`Select ${field.title}`}
                            />
                        </span>
                    </div>
                    {field.deletable &&
                        <span style={{ paddingLeft: '10px' }}>
                            <button className="customBtn btnDanger btnRounded" onClick={() => { this.removeField(index, field) }}><IoMdRemove /></button>
                        </span>
                    }
                </Col>
            }
            else if (field.type === 'text') {
                return <Col md={6} style={{ marginTop: '10px', display: 'flex', alignItems: 'end' }} key={field.name}>
                    <div style={{ width: '90%' }}>
                        <label>{field.title}</label>
                        <input className="form-control" type="text" onChange={this.handleSearchInputs}
                            name={field.name} value={this.state.filter_values[field.name] ? this.state.filter_values[field.name].value : ''} />
                    </div>
                    {field.deletable &&
                        <span style={{ paddingLeft: '10px' }}>
                            <button className="customBtn btnDanger btnRounded" onClick={() => { this.removeField(index, field) }}><IoMdRemove /></button>
                        </span>
                    }
                </Col>
            }
            else if (field.type === 'order_date') {
                return <Col md={6} style={{ marginTop: '10px' }} key={field.name}>
                    <div className="row" style={{ width: '93%' }} >
                        <div className="col-md-8">
                            <span>Order Date:</span>
                            <span>
                                <DateRangePicker
                                    className="form-control"
                                    onChange={(e) => this.handleSearchDatePicker(field, e)}
                                    value={this.state.filter_values[field.name] ? this.state.filter_values[field.name].value : null}
                                    placeholderText={`11/06/2022 - 11/22/2022`}
                                />
                            </span>
                        </div>
                        <div className="col-md-4">
                            <span>Time Created:</span>
                            <span>
                                <Select
                                    value={this.state.filter_values[`${field.name}_by_days`] || ''}
                                    onChange={(event, info) => this.handleSearchDropdowns(event, info, field)}
                                    options={this.getDropdownOptions(field.name)}
                                    getOptionLabel={(option) => option.title}
                                    getOptionValue={(option) => option.id}
                                    isSearchable={true}
                                    isClearable={true}
                                    name={field.name}
                                    placeholder={'Select Days'}
                                />
                            </span>
                        </div>
                    </div>
                </Col>
            } else if (field.type === 'date') {
                return <Col md={6} style={{ marginTop: '10px', display: 'flex', alignItems: 'end' }} key={field.name}>
                    <div style={{ width: '90%' }} >
                        <label>{field.title}</label>
                        <span>
                            <DateRangePicker
                                className="form-control"
                                onChange={(e) => this.handleSearchDatePicker(field, e)}
                                value={this.state.filter_values[field.name] ? this.state.filter_values[field.name].value : null}
                                placeholderText={`11/06/2022 - 11/22/2022`}
                            />
                        </span>
                    </div>
                    {field.deletable &&
                        <span style={{ paddingLeft: '10px' }}>
                            <button className="customBtn btnDanger btnRounded" onClick={() => { this.removeField(index, field) }}><IoMdRemove /></button>
                        </span>
                    }
                </Col>
            }
        });
    }

    submitSearchFilters = async () => {
        this.setState({
            ...this.state,
            add_filters: true,
            included_filters: { ...this.state.filter_values },
        }, () => {
            this.setSessionStorage();
            this.refreshOrdersList();
            this.downloadData();
        })
    }

    clearFilters = () => {
        this.setState({
            ...this.state,
            add_filters: false,
            filter_values: {},
            included_filters: {}
        }, () => {
            this.setSessionStorage();
            this.refreshOrdersList();
            this.downloadData();
        })
    }

    handleBulkEditSubmit = (success) => {
        if (success) {
            this.setState({
                selected_orders_ids: []
            }, () => {
                this.refreshOrdersList();
            })
        }
    }


    downloadData = () => {
        const { add_filters, included_filters } = this.state;
        return this.props.getOrdersListCall(
            this.state.brandId || '',
            this.state.page,
            this.state.pageSize,
            '',
            false,
            { filter: add_filters ? included_filters : null }
        ).then(response => {
            var data_to_download = []
            const tableCols = [...this.state.table_columns];
            const columnsData = tableCols[0].columns;
            for (var index = 0; index < response.length; index++) {
                let record_to_download = {}
                var temp = response[index];
                for (var colIndex = 0; colIndex < columnsData.length; colIndex++) {
                    if (columnsData[colIndex].excExp) {
                        record_to_download[columnsData[colIndex].Header] = temp[columnsData[colIndex].accessor]
                    }
                }
                data_to_download.push(record_to_download)
            }
            this.setState({ orders_to_download: data_to_download })
        });
    }

    setSessionStorage() {
        sessionStorage.setItem("orderGridState", JSON.stringify({
            orders: this.state.orders,
            orders_to_download: this.state.orders_to_download,
            filter_values: this.state.filter_values,
            add_filters: this.state.add_filters,
            included_filters: this.state.included_filters,
            additional_filters: this.state.additional_filters,
        }))
    }

    componentWillUnmount = () => {
        // this.setSessionStorage();
    }

    render() {
        const { filtered } = this.state;
        const { pages, loading } = this.props;
        const columns = this.state.table_columns;
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3
                                                        style={{
                                                            textAlign: "center",
                                                            fontWeight: "500",
                                                            textTransform:
                                                                "capitalize"
                                                        }}
                                                    >Orders list</h3>
                                                </Col>

                                                <Col md={12}>
                                                    <Col md={12}>
                                                        <Row>
                                                            {this.renderAdditionalFilters()}
                                                        </Row>
                                                        <Row>
                                                            <Col md={8} style={{ marginTop: "20px", paddingLeft: '0px' }}>
                                                                <div>
                                                                    <Col md={4} >
                                                                        <span>
                                                                            <label>
                                                                                Add Field:
                                                                            </label>
                                                                            <Select
                                                                                value={this.state.selectedField}
                                                                                onChange={this.handleFieldDropdown}
                                                                                getOptionLabel={(option) => option.title}
                                                                                getOptionValue={(option) => option.name}
                                                                                options={dropdownFields}
                                                                                isSearchable={true}
                                                                                name='field_selector'
                                                                                placeholder={'Select Field'}
                                                                            />
                                                                        </span>
                                                                    </Col>
                                                                    <Col md={1} style={{ marginTop: '20px' }}>
                                                                        <button className="customBtn btnBlue btnRounded" onClick={this.addNewField}><IoMdAdd /></button>
                                                                    </Col>
                                                                </div>
                                                            </Col>
                                                            <Col md={4} style={{ display: 'flex', justifyContent: 'end', marginTop: "20px" }}>
                                                                <div>
                                                                    <button type="button"
                                                                        onClick={this.submitSearchFilters}
                                                                        style={{
                                                                            width: '150px',
                                                                            marginRight: '15px'
                                                                        }}
                                                                        className="customBtn btnBlack btn-lg">
                                                                        Search
                                                                    </button>
                                                                </div>
                                                                <div>
                                                                    <button type="button"
                                                                        onClick={this.clearFilters}
                                                                        style={{
                                                                            width: '150px',
                                                                            backgroundColor: 'tomato'
                                                                        }}
                                                                        className="customBtn btnBlack btn-lg">
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>


                                                <Modal show={this.state.addModal}
                                                    onHide={HF.closeModal.bind(this, "addModal")}
                                                    aria-labelledby="ModalHeader"
                                                    backdrop={false}>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title id='ModalHeader'
                                                            className="headerTitle"> Bulk Update
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className="row">
                                                            <div className="col-md-8 col-md-offset-2">
                                                                <OrderBulkEditForm
                                                                    closeModal={HF.closeModal.bind(this, "addModal")}
                                                                    orders_ids={this.state.selected_orders_ids}
                                                                    return_submitted_data={this.handleBulkEditSubmit}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>

                                            </Row>
                                            <Row className="mt-md">
                                                <Col md={12}>
                                                    <div
                                                        className=" mt-xlg flexResponsive"
                                                        style={{
                                                            alignItems:
                                                                "flex-start",
                                                            justifyContent:
                                                                "space-between"
                                                        }}
                                                    >

                                                        {!hasPermission('change-order-status') &&
                                                            <div style={{ float: "left", width: "270px", paddingRight: "20px" }}>
                                                                <Link
                                                                    to={`/Admin/create-order`}
                                                                    className="customBtn btnBlue"
                                                                >
                                                                    Create Order
                                                                </Link>
                                                            </div>
                                                        }

                                                        {hasPermission('change-order-status') &&
                                                            <div style={{ float: "left", width: "270px" }}>
                                                                <button className="customBtn BtnBlack"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            addModal: !this.state.addModal
                                                                        })
                                                                    }}
                                                                    disabled={this.state.selected_orders_ids.length > 0 ? false : true}
                                                                >Bulk Edit</button>
                                                            </div>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <div className="downloadCsv">
                                                    <CSVDownloader
                                                        data={this.state.orders_to_download}
                                                        ref={(r) => this.csvLink = r}
                                                        filename={"Orders_List_" + moment().format('YYYY_MM_DD')}
                                                        config={{
                                                            delimiter: '\t',
                                                        }}
                                                        bom={true}
                                                    >
                                                        <button type="button">
                                                            Download
                                                        </button>
                                                    </CSVDownloader>
                                                </div>
                                            </Row>
                                            <Row>
                                                <Col md={12} className="mt-md">
                                                    <ReactTable
                                                        noDataText="No data found"
                                                        data={this.state.orders}
                                                        pages={pages}
                                                        style={{ zIndex: 0, fontSize: '12px' }}
                                                        loading={loading}
                                                        columns={columns}
                                                        filtered={filtered}
                                                        defaultPageSize={10}
                                                        className="-striped listing responsive"
                                                        pageData={
                                                            this
                                                                .ordersPaginationData
                                                        }
                                                        manual
                                                        // sortable={false}
                                                        onFetchData={(
                                                            state,
                                                            instance
                                                        ) => {
                                                            var sort =
                                                                state.sorted
                                                                    .length ===
                                                                    0
                                                                    ? ""
                                                                    : state
                                                                        .sorted[0]
                                                                        .id +
                                                                    ",desc:" +
                                                                    state
                                                                        .sorted[0]
                                                                        .desc;
                                                            state.pageData(
                                                                state.page + 1,
                                                                state.filtered,
                                                                sort,
                                                                state.pageSize
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col >
                    </Row >
                </Grid >
            </div >
        );
    }
}

OrderList.defaultProps = {
    print_location: [],
    orderStatuses: [],
    brands: [],
};

const mapDispatchToProps = dispatch => {
    return {
        getListCall: (
            id, page, filter, sort, pageSize, component_name, pagination
        ) => {
            dispatch(
                listActions.getList(
                    id, page, filter, sort, pageSize, component_name, pagination
                )
            );
        },
        saveOrderStatusCall: (data) => {
            return dispatch(
                createOrderActions.saveOrderStatus(
                    data
                )
            );
        },
        getShippingOptions: custId => {
            dispatch(shippingOptionsActions.getCustomerShippingOptions(custId));
        },
        getOrdersListCall: (
            id,
            page,
            pageSize,
            sort,
            pagination,
            data
        ) => {
            let resource_id = "all";
            if (id !== undefined && id !== '') {
                resource_id = id;
            }

            //
            return dispatch(
                createOrderActions.getOrdersList(
                    resource_id,
                    page,
                    pageSize,
                    sort,
                    pagination,
                    data
                )
            );
        },
        getAllBrands: (page, filter, sort, pageSize) => {
            return dispatch(
                brandActions.getBrandsListDropDown(page, filter, sort, pageSize)
            );
        },
        getCustomerBrands: () => {
            return dispatch(
                createOrderActions.getCustomerBrandsList(true)
            );
        },
        errorAlert: (e) => {
            dispatch(alertActions.error(e))
        },
        successAlert: (msg) => {
            dispatch(alertActions.success(msg))
        },
    };
};

function mapStateToProps(state) {
    const { order_status, print_location } = state.listReducer;
    const { shippingOptions } = state.shippingOptionReducer;
    const {
        ordersData,
        pages,
        loadingOrder,
        current_page,
        total_orders,
    } = state.ordersReducer;
    return {
        loading: loadingOrder,
        ordersData,
        print_location,
        pages,
        current_page,
        total_orders,
        orderStatuses: order_status,
        shippingOptions,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OrderList)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/OrderList.jsx